import { apiPostCall } from '@precisionplanting/node-api/frontend';

/**
 * Returns a string with a shortened file size like '1.3 MB'.
 * @param size bytes
 * @returns {string}
 */
const fileSizeHR = (size, noSpace) => {
	let unit;
	for (const thisUnit of [``, `K`, `M`, `G`]) {
		unit = thisUnit;
		if (+size < 1000) break;
		// eslint-disable-next-line no-param-reassign
		size /= 1000;
	}
	return `${Math.round(size * 10) / 10}${noSpace ? `` : ` `}${unit}B`;
};

// eslint-disable-next-line no-undef
const getWsURL = () => `${window.COMPILED ? `/register/2020/ajax.php` : `/uploading-a-file-doesnt-work-in-local`}`;

const request = async function ({ action, ...data }, hideLoader) {
	// eslint-disable-next-line @typescript-eslint/no-invalid-this
	const { $root } = this;
	const updatePendingOperations = !hideLoader && $root;
	const loader = $root?.$children[0].$refs.loader;
	if (updatePendingOperations) loader.numPendingOperations++;
	let rsp;
	try {
		rsp = await (
			await (action == `create_user`
				? // eslint-disable-next-line no-undef
				fetch(
					getWsURL(),
					{
						method: `POST`,
						cache: `no-cache`,
						credentials: `include`,
						headers: { 'Content-Type': `application/x-www-form-urlencoded` },
						redirect: `follow`,
						referrer: `no-referrer`,
						// eslint-disable-next-line no-undef
						body: new URLSearchParams({ ...data, action })
					}
				)
				: apiPostCall(action, data))
		)
			.json();
	}
	catch (error) {
		// eslint-disable-next-line no-console, no-undef
		console.error(`request() error`, error, data);
	}
	if (updatePendingOperations) loader.numPendingOperations--;
	return rsp;
};

// eslint-disable-next-line import/no-unused-modules
export default {
	methods: {
		getWsURL,
		fileSizeHR,
		request,
		reloadForm () {
			// eslint-disable-next-line no-undef
			if (this.$route.path === `/review`) window.location = `/register`;
			// eslint-disable-next-line no-undef
			else window.location.reload();
		},
		validPhone: phone => phone.replaceAll(/\D/g, ``).length >= 10,
		validEmail: email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
		xs: num => num == 1 ? `` : `s`,
		getAccountType (id) {
			if (id == 0) return `Customer`;
			if (id == 1) return `Dealer`;
			if (id == 2) return `Internal Support`;
			if (id == 3) return `Dealer Employee`;
		},
		formatPhone (phone) {
			const strPhone = `${phone}`;
			return strPhone.length == 10
				? `(${strPhone.slice(0, 3)})-${strPhone.slice(3, 6)}-${strPhone.slice(6)}`
				: `${strPhone.slice(0, 3)}-${strPhone.slice(3)}`;
		},
		/**
		 * Call to emit an event that can be listened to at a higher-than-parent level.
		 */
		bubbleEvent (eventName, data) {
			// eslint-disable-next-line no-undef
			this.$el.dispatchEvent(new CustomEvent(eventName, { detail: data, bubbles: true, composed: true }));
		},
		/**
		 * Call this in $.mounted function to listen for events
		 * that bubble from components deeper than direct children.
		 * */
		listenForBubble (eventName, callback) {
			this.$el.addEventListener(eventName, e => callback(e.detail));
		}
	}
};